// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Rating/Rating.less
// module id = 228
// module chunks = 2